import { SxStyle } from '@aibees/shared/theme';

export const label: SxStyle = {
  maxWidth: (p) => p.spacing(20),
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  display: 'block',
};
